<template>
  <section class="list-filter-section">
    <div class="partners-filter-box list-box">
       <div class="filter-box-title">검색어 입력
        <input type="text" class="filter_input" v-model="search_text" v-on:keyup.enter="search_by_text">
         <div class="filter_search" @click="search_by_text"><i class="fas fa-search "></i></div>
      </div>
       <div class="selector-list">
        <div class="selector-list-title">추천업체</div>
         <div class="selector-item-list">
          <label class="control control--checkbox" style="font-size: 14px; font-weight: bold;color: #555555;">프리미엄
              <input type="checkbox"   v-model="is_premium_view" />
              <div class="control__indicator"></div>
          </label>
         </div>
       </div>
        
      <div class="selector-list">
        <div class="selector-list-title">회사 분류</div>
        <div class="selector-item-list">
          <div class="selector-item company_filter"
               v-for="(cat, index) in service_filters"
               :key = "'cat'+index"
          >
           <div class="radio">
              <input
                :id="'partener_cat' + index"
                name="radio"
                type="radio"
                :value="cat.category_title"
                v-model="selected_service_filters"
                checked
              />
              <label :for="'partener_cat' + index" class="radio-label">{{cat.category_title}}
              </label>
            </div>  
          </div>          
        </div>
      </div>
      <div class="selector-list">
        <div class="selector-list-title">서비스 필터</div>
        <div class="selector-item-list">
           <div class="selector-item company_filter" >
           <div class="radio">
              <input
                :id="'partener_det_cat' + '-1'"
                name="radio-det"
                type="radio"
                :value="detail_service_filters"
                v-model="selected_detail_service_filters"
                checked
              />
              <label :for="'partener_det_cat' + '-1'" class="radio-label">전체
              </label>
            </div>  
          </div>
          <div class="selector-item company_filter"
               v-for="(cat, index) in detail_service_filters"
               :key = "'cat'+index"
          >
           <div class="radio">
              <input
                :id="'partener_det_cat' + index"
                name="radio-det"
                type="radio"
                :value="cat"
                v-model="selected_detail_service_filters"
              />
              <label :for="'partener_det_cat' + index" class="radio-label">{{cat.title}}
              </label>
            </div>  
          </div>  
        </div>
      </div>
      <div class="selector-list">
        <div class="selector-list-title">파트너 지역</div>
        <div class="selector-item-list">          
          <div class="selector-item" >
            <div class="radio">
              <input
                :id="'partener_det_loc' + -1"
                name="radio2"
                type="radio"
                :value="local_filters"
                v-model="selected_local_filters_id"
                checked
              />
              <label :for="'partener_det_loc' + -1" class="radio-label">전체
              </label>
            </div>       
          </div>
          <div class="selector-item" 
               v-for="(cat, index) in local_filters"
               :key = "'cat'+index"
          >
            <div class="radio">
              <input
                :id="'partener_det_loc' + index"
                name="radio2"
                type="radio"
                :value="cat"
                v-model="selected_local_filters_id"
              />
              <label :for="'partener_det_loc' + index" class="radio-label">{{
                cat
              }}</label>
            </div>
          </div>
        </div>
      </div>      
    </div>
    <div class="apply-request-helper"></div>
  </section>
</template>
<script>
import EventBus from "@/EventBus.js";
export default {
  data(){
    return{
      selected_detail_service_filters:[],
      detail_service_filters:[],
      selected_service_filters:[],
      service_filters:[],
      selected_local_filters:[],    
      local_filters:[],
      selected_cert_filters:"",
      search_text:"",
      is_premium_view:true,
      selected_local_filters_id:"",
      local_all:"",
      is_first:true 
    }
  },
  watch:{
    selected_service_filters(new_val, old_val){
      this.detail_service_filters = []
      for(var k = 0; k < new_val.length; k++){  
        this.detail_service_filters =  this.service_filters.find(x => x.category_title ===new_val).category_service_filter 
      }
      // 최초는 전체로 선택해준다
      this.selected_detail_service_filters = this.detail_service_filters
      if(this.is_first != true)      
      this.send_company_filter()
    },
    selected_detail_service_filters(){
       if(this.is_first != true)    
      this.send_company_filter()
    },
    selected_local_filters(){
       if(this.is_first != true)    
      this.send_company_filter()
    },
    is_premium_view(){
       if(this.is_first != true)    
      this.send_company_filter()
    },
    selected_local_filters_id(){
       if(this.is_first != true)    
       this.send_company_filter()
    }
  },
  methods:{
    search_by_text(){
      EventBus.$emit("sesarch_text", this.search_text)
    },
    send_company_filter(){
      let local_array = []
      console.log(this.getType(this.selected_local_filters_id))
      if( this.getType(this.selected_local_filters_id) == "Array"  ){
        local_array = this.selected_local_filters_id
      }else{
        local_array.push(this.selected_local_filters_id)
      }
      
      var data = {
        is_premium_view : this.is_premium_view,
        selected_detail_service_filters:this.selected_detail_service_filters,
        selected_service_filters :this.selected_service_filters,
        selected_local_filters : local_array ,
        selected_cert_filters : this.selected_cert_filters,
      }
      EventBus.$emit("company_filter", data);
    },    
      getType(x) {
        if (x == null) {
            return 'null';
        }
    
        var t = typeof x;
        if (t != "object") {
            return t;
        }
    
        var c = Object.prototype.toString.apply(x);
        c = c.substring(8, c.length - 1); // [object ?]의 특성을 이용함
    
        if (c != "Object") {
            return c;
        }
    
        if (c.constructor == "Object") {
            return c;
        } else {
            var s = x.constructor.toString();
            var i = s.indexOf("(");
            return s.substring(9, i); // function ?( ... 의 특성을 이용함
        }
    
        return "unknown type";
    }
  },
  mounted(){
    this.$http.get("app/get_matching_filter",).then(res=>{     
      this.service_filters = res.data["서비스"]
      this.local_filters = res.data["지역"]["local_filter"]
      this.selected_local_filters_id = this.local_filters
      console.log(this.$route.query.main_q)
      if( this.$route.query.main_q != undefined){       
        console.log("this") 
        this.detail_service_filters = []       
        this.detail_service_filters = this.detail_service_filters.concat( this.service_filters.find(x => x.category_id === parseInt(this.$route.query.main_q)).category_service_filter  )
        let input_value = this.service_filters.find(x => x.category_id === parseInt(this.$route.query.main_q)).category_title
        this.$nextTick(function(){
          $('input[value="'+ input_value +'"]').click()
        })
        var data = {
            selected_detail_service_filters:this.selected_detail_service_filters,
            selected_service_filters :this.selected_service_filters,
            selected_local_filters : this.selected_local_filters,
            selected_cert_filters : this.selected_cert_filters,
            is_premium_view:true,
          }
          EventBus.$emit("company_filter", data);
          this.is_first = false
      }else{
       
        this.$nextTick(function(){
          
          $('.company_filter:eq(0)').find("input").click()          
          this.selected_detail_service_filters=this.selected_detail_service_filters.concat( this.service_filters[0].category_service_filter )
          var data = {
            selected_detail_service_filters:this.selected_detail_service_filters,
            selected_service_filters :this.selected_service_filters,
            selected_local_filters : this.selected_local_filters,
            selected_cert_filters : this.selected_cert_filters,
            is_premium_view:true,
          }
          EventBus.$emit("company_filter", data);
          this.is_first = false
        })
      }
    })
  }
};
</script>

<style scoped lang="scss">

 
  .filter_input{
    width: 100%;
    padding: 2px 3px; 
    font-size: 14px;
    color: #696969;
    margin-top: 5px;    
  }
  .filter_search{
    position: absolute;
    top: 34px;
    right: 10px;
    color:#888484;
    cursor: pointer;
  }
.list-filter-section {
  width: 200px;
  float: left;
  .list-box {
    *zoom: 1;
    background-color: #ffffff;
    border-radius: 2px;
    box-shadow: 0 1px 0 0 #dedede;
    border: 1px solid #dedede;
    padding: 16px;
    .filter-box-title {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      padding: 0 4px 12px 4px;
      border-bottom: 1px solid #dedede;
      margin-bottom: 12px;
      position:relative;
    }
    .selector-list {
      padding: 0 4px;
      margin: 0 0 16px 0;
      .help_text{
        font-size: 14px;
        color:#666;
      }
      .selector-list-title {
        font-size: 14px;
        font-weight: bold;
        color: #555555;
      }
      .selector-item-list {
        margin: 5px 0 10px 0;
        input {
          margin: 0;
        }
        label {
          display: inline-block;
          font-size: 12px;
          font-weight: normal;
          color: #555555;
          margin: 0 0 0 10px;
        }
      }
    }
  }
  .apply-request-helper {
    margin-top: 6px;
    cursor: pointer;
    font-weight: bold;
  }
  $color1: #f4f4f4;
$color2: #3197ee;

.radio {

  input[type="radio"] {
    position: absolute;
    opacity: 0;
    + .radio-label {
      &:before {
        content: "";
        background: $color1;
        border-radius: 100%;
        border: 1px solid darken($color1, 25%);
        display: inline-block;
        width: 1.4em;
        height: 1.4em;
        position: relative;
        top: 0em;
        margin-right: 1em;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: $color2;
          box-shadow: inset 0 0 0 4px $color1;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color2;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color1;
          border-color: darken($color1, 25%);
          background: darken($color1, 25%);
        }
      }
    }
    + .radio-label {
      cursor: pointer;
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}
}

</style>



// WEBPACK FOOTER //
// src/SPA/CompanyList/Components/CompanyListFilter.vue